import { render, staticRenderFns } from "./RoleInput.vue?vue&type=template&id=9caf5f64&scoped=true&"
import script from "./RoleInput.vue?vue&type=script&lang=js&"
export * from "./RoleInput.vue?vue&type=script&lang=js&"
import style0 from "./RoleInput.vue?vue&type=style&index=0&id=9caf5f64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9caf5f64",
  null
  
)

export default component.exports